var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleQuestionMark = function SvgCircleQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.75 7.25v-1.5h4.5V8.5L10 10v1.25M10 14v-.01M19.25 10a9.25 9.25 0 1 1-18.5 0 9.25 9.25 0 0 1 18.5 0m-9 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
  })));
};
export default SvgCircleQuestionMark;